export default function multipartAuthHeader() {
  return { 'Content-Type': 'multipart/form-data' };
}